/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["ug",[["ب","ك"],["چ.ب","چ.ك"],["چۈشتىن بۇرۇن","چۈشتىن كېيىن"]],[["چ.ب","چ.ك"],u,u],[["ي","د","س","چ","پ","ج","ش"],["يە","دۈ","سە","چا","پە","جۈ","شە"],["يەكشەنبە","دۈشەنبە","سەيشەنبە","چارشەنبە","پەيشەنبە","جۈمە","شەنبە"],["ي","د","س","چ","پ","ج","ش"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["يانۋار","فېۋرال","مارت","ئاپرېل","ماي","ئىيۇن","ئىيۇل","ئاۋغۇست","سېنتەبىر","ئۆكتەبىر","نويابىر","دېكابىر"],u],u,[["BCE","مىلادىيە"],u,["مىلادىيەدىن بۇرۇن","مىلادىيە"]],0,[6,0],["y-MM-dd","d-MMM، y","d-MMMM، y","y d-MMMM، EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1}، {0}",u,"{1} {0}",u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"CNY","￥","جۇڭگو يۈەنى",{"CNY":["￥","¥"],"JPY":["JP¥","¥"]},"rtl", plural];
